/* =========================================================
   UNISOURCE TRUSTED BRANDS
   v12 - Shopify Brand blocks + API enrichment
========================================================= */

(function () {
  "use strict";

  var DIRECT_AZURE_API =
    "https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/home-brands?take=250";

  var BRAND_LOGO_VERSION = "20260722-v12";

  var BRAND_DISPLAY_OVERRIDES = {
    "cotton heritage": {
      id: "cotton-in",
      name: "Cotton-IN",
      slug: "cotton-in",
      productUrl: "/pages/product?brand=Cotton-IN",
      logoUrl: "https://cdn.inksoft.com/images/publishers/2959/brands/CottonIN/200w.gif"
    },
    "cotton in": {
      id: "cotton-in",
      name: "Cotton-IN",
      slug: "cotton-in",
      productUrl: "/pages/product?brand=Cotton-IN"
    },
    "zuni": {
      name: "ZUNI Sportswear",
      slug: "zuni-sportswear",
      productUrl: "/pages/product?brand=ZUNI%20Sportswear"
    },
    "beimar": {
      name: "Beimar Drop Ship",
      slug: "beimar-drop-ship",
      productUrl: "/pages/product?brand=Beimar%20Drop%20Ship"
    }
  };

  function text(value) {
    return String(value == null ? "" : value).trim();
  }

  function normalize(value) {
    return text(value)
      .toLowerCase()
      .replace(/&amp;/g, "&")
      .replace(/\+/g, " plus ")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .replace(/\s+/g, " ");
  }

  function rootPath(url) {
    var value = text(url);
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return value;
    return value.charAt(0) === "/" ? value : "/" + value;
  }

  function unique(values) {
    var output = [];
    var seen = {};

    values.forEach(function (value) {
      var item = text(value);
      var key = item.toLowerCase();
      if (!item || seen[key]) return;
      seen[key] = true;
      output.push(item);
    });

    return output;
  }

  function cacheBustUrl(url) {
    var value = text(url);
    if (!value) return "";

    try {
      var absolute = new URL(value, window.location.origin);
      absolute.searchParams.set("uhBrandLogoV", BRAND_LOGO_VERSION);
      return absolute.href;
    } catch (error) {
      return value +
        (value.indexOf("?") === -1 ? "?" : "&") +
        "uhBrandLogoV=" +
        encodeURIComponent(BRAND_LOGO_VERSION);
    }
  }

  function buildUrl(base, brand) {
    var url = rootPath(base) || "/pages/product";

    try {
      var absolute = new URL(url, window.location.origin);
      absolute.searchParams.set("brand", brand);
      return absolute.pathname + absolute.search + absolute.hash;
    } catch (error) {
      return url +
        (url.indexOf("?") === -1 ? "?" : "&") +
        "brand=" +
        encodeURIComponent(brand);
    }
  }

  function buildApiCandidates(apiUrl) {
    return unique([
      rootPath(apiUrl) || DIRECT_AZURE_API,
      DIRECT_AZURE_API,
      "/apps/inksoft/home-brands?take=250",
      "/apps/inksoft/poc/home-brands?take=250",
      "/api/poc/home-brands?take=250"
    ]);
  }

  function normalizePayload(payload) {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload && payload.data)) return payload.data;
    if (Array.isArray(payload && payload.brands)) return payload.brands;
    return [];
  }

  function fetchJson(url) {
    return fetch(url, {
      headers: { Accept: "application/json" },
      credentials: /^https?:\/\//i.test(url) ? "omit" : "same-origin"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Brands request failed: " + response.status + " " + url);
      }
      return response.json();
    });
  }

  function fetchFirstWorking(urls) {
    var index = 0;

    function next(lastError) {
      if (index >= urls.length) {
        throw lastError || new Error("No brand API URL worked.");
      }

      return fetchJson(urls[index++]).catch(function (error) {
        console.warn("[Trusted Brands] API failed, trying next:", error.message);
        return next(error);
      });
    }

    return next();
  }

  function normalizeBrandForDisplay(brand) {
    var override =
      BRAND_DISPLAY_OVERRIDES[normalize(brand && brand.name)] ||
      BRAND_DISPLAY_OVERRIDES[normalize(brand && brand.id)] ||
      BRAND_DISPLAY_OVERRIDES[normalize(brand && brand.slug)];

    if (!override && String((brand && brand.manufacturerId) || "") === "1000098") {
      override = BRAND_DISPLAY_OVERRIDES["cotton heritage"];
    }

    return override ? Object.assign({}, brand, override) : brand;
  }

  function getLogoUrl(brand) {
    var candidates = []
      .concat(Array.isArray(brand && brand.logoUrls) ? brand.logoUrls : [])
      .concat([
        brand && brand.logoUrl,
        brand && brand.imageUrl,
        brand && brand.logo,
        brand && brand.image
      ])
      .filter(Boolean);

    return unique(candidates)[0] || "";
  }

  function createLogoLayers(name, logoUrl) {
    var fragment = document.createDocumentFragment();
    var resolvedUrl = cacheBustUrl(logoUrl);

    var mask = document.createElement("span");
    mask.className = "unisource-home__brand-logo-mask";
    mask.setAttribute("role", "img");
    mask.setAttribute("aria-label", name);
    mask.style.setProperty(
      "--brand-logo-url",
      'url("' + resolvedUrl.replace(/"/g, "%22") + '")'
    );

    var original = document.createElement("img");
    original.className = "unisource-home__brand-logo-original";
    original.src = resolvedUrl;
    original.alt = name;
    original.loading = "lazy";

    fragment.appendChild(mask);
    fragment.appendChild(original);

    return fragment;
  }

  function createFallback(name) {
    var fallback = document.createElement("span");
    fallback.className = "unisource-home__brand-logo-fallback";
    fallback.textContent = name;
    return fallback;
  }

  function apiBrandCard(brand, productUrl) {
    brand = normalizeBrandForDisplay(brand);

    var name = text(brand.name);
    var logoUrl = getLogoUrl(brand);
    var link = document.createElement("a");

    link.className = "unisource-home__brand-logo-card";
    link.href = text(brand.productUrl) || buildUrl(productUrl, name);
    link.setAttribute("aria-label", "View " + name + " products");
    link.setAttribute("title", name);
    link.dataset.brandFilter = name;
    link.dataset.brandDisplay = name;

    var media = document.createElement("span");
    media.className = "unisource-home__brand-logo-media";
    media.appendChild(logoUrl ? createLogoLayers(name, logoUrl) : createFallback(name));
    link.appendChild(media);

    return link;
  }

  function dedupeApiBrands(brands) {
    var seen = {};

    return brands
      .map(normalizeBrandForDisplay)
      .filter(function (brand) {
        var key = normalize(brand && brand.name);
        if (!key || seen[key]) return false;
        seen[key] = true;
        return true;
      })
      .sort(function (a, b) {
        return text(a.name).localeCompare(text(b.name), undefined, {
          sensitivity: "base",
          numeric: true
        });
      });
  }

  function enrichManualCards(cards, apiBrands, productUrl) {
    var map = {};

    apiBrands.forEach(function (brand) {
      [
        brand.name,
        brand.id,
        brand.slug
      ].forEach(function (candidate) {
        var key = normalize(candidate);
        if (key && !map[key]) map[key] = brand;
      });
    });

    cards.forEach(function (card) {
      var filterValue = text(card.dataset.brandFilter);
      var displayName = text(card.dataset.brandDisplay) || filterValue;
      var useApiLogo = card.dataset.useApiLogo === "true";
      var media = card.querySelector(".unisource-home__brand-logo-media");
      var hasCustomLogo = !!card.querySelector(".unisource-home__brand-logo-mask--custom");
      var match = map[normalize(filterValue)] || map[normalize(displayName)];

      if (!card.getAttribute("href") || card.getAttribute("href") === productUrl) {
        card.href = buildUrl(productUrl, filterValue || displayName);
      }

      if (useApiLogo && !hasCustomLogo && match && media) {
        var logoUrl = getLogoUrl(match);

        if (logoUrl) {
          media.innerHTML = "";
          media.appendChild(createLogoLayers(displayName, logoUrl));
        }
      }
    });
  }

  function getColumns(root) {
    var desktop = Math.max(5, Math.min(6, Number(root.dataset.brandsPerGroup) || 6));
    if (window.matchMedia("(max-width: 549px)").matches) return 2;
    if (window.matchMedia("(max-width: 899px)").matches) return 4;
    return desktop;
  }

  function init(root) {
    var grid = root.querySelector("[data-brands-grid]");
    var viewport = root.querySelector("[data-brand-viewport]");
    var status = root.querySelector("[data-brands-status]");
    var previous = root.querySelector("[data-brand-prev]");
    var next = root.querySelector("[data-brand-next]");
    var pagination = root.querySelector("[data-brand-pagination]");

    if (!grid || !viewport) return;

    var sourceMode = text(root.dataset.brandsSourceMode) || "manual";
    var productUrl = rootPath(root.dataset.brandsProductUrl) || "/pages/product";
    var apiUrl = rootPath(root.dataset.brandsApiUrl) || DIRECT_AZURE_API;
    var max = Math.max(1, Number(root.dataset.brandsMax) || 30);
    var autoplay = root.dataset.brandsAutoplay === "true";
    var autoplaySeconds = Math.max(3, Number(root.dataset.brandsAutoplaySeconds) || 6);

    var manualCards = Array.prototype.slice.call(
      grid.querySelectorAll("[data-brand-manual-card]")
    );

    var activeCards = manualCards.slice();
    var apiBrands = [];
    var pageIndex = 0;
    var pageCount = 1;
    var timer = 0;

    function stopAutoplay() {
      window.clearInterval(timer);
      timer = 0;
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || pageCount <= 1) return;

      timer = window.setInterval(function () {
        goTo((pageIndex + 1) % pageCount);
      }, autoplaySeconds * 1000);
    }

    function goTo(index) {
      pageIndex = Math.max(0, Math.min(pageCount - 1, index));
      grid.style.transform = "translateX(-" + pageIndex * 100 + "%)";

      if (previous) previous.disabled = pageIndex === 0;
      if (next) next.disabled = pageIndex === pageCount - 1;

      if (pagination) {
        pagination.querySelectorAll("[data-brand-page]").forEach(function (dot, dotIndex) {
          var active = dotIndex === pageIndex;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-current", active ? "true" : "false");
        });
      }
    }

    function render(cards) {
      var columns = getColumns(root);
      var visible = cards.slice(0, max);

      pageCount = Math.max(1, Math.ceil(visible.length / columns));
      pageIndex = Math.min(pageIndex, pageCount - 1);

      grid.innerHTML = "";

      for (var start = 0; start < visible.length; start += columns) {
        var page = document.createElement("div");
        page.className = "unisource-home__brand-page";
        page.style.setProperty("--brand-columns", String(columns));

        visible.slice(start, start + columns).forEach(function (card) {
          page.appendChild(card);
        });

        grid.appendChild(page);
      }

      if (pagination) {
        pagination.innerHTML = "";

        for (var index = 0; index < pageCount; index += 1) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "unisource-home__brand-dot";
          dot.dataset.brandPage = String(index);
          dot.setAttribute("aria-label", "Show brand group " + (index + 1));
          dot.addEventListener("click", function () {
            goTo(Number(this.dataset.brandPage));
            startAutoplay();
          });
          pagination.appendChild(dot);
        }

        pagination.hidden = pageCount <= 1;
      }

      if (previous) {
        previous.hidden = pageCount <= 1;
        previous.onclick = function () {
          goTo(pageIndex - 1);
          startAutoplay();
        };
      }

      if (next) {
        next.hidden = pageCount <= 1;
        next.onclick = function () {
          goTo(pageIndex + 1);
          startAutoplay();
        };
      }

      goTo(pageIndex);
      startAutoplay();
    }

    function buildCardsFromMode() {
      var selected = [];

      if (sourceMode === "api") {
        selected = apiBrands.map(function (brand) {
          return apiBrandCard(brand, productUrl);
        });
      } else {
        enrichManualCards(manualCards, apiBrands, productUrl);
        selected = manualCards.slice();

        if (sourceMode === "hybrid" && selected.length < max) {
          var existing = {};

          selected.forEach(function (card) {
            existing[normalize(card.dataset.brandFilter || card.dataset.brandDisplay)] = true;
          });

          apiBrands.forEach(function (brand) {
            var key = normalize(brand.name);
            if (!key || existing[key] || selected.length >= max) return;
            existing[key] = true;
            selected.push(apiBrandCard(brand, productUrl));
          });
        }
      }

      activeCards = selected;
      render(activeCards);

      if (status) status.hidden = true;
    }

    if (status) {
      status.hidden = false;
      status.textContent = "Loading trusted brands…";
    }

    /*
      Manual mode can render immediately. We still load the API in the
      background when a block requests an API logo.
    */
    if (sourceMode === "manual" && manualCards.length) {
      render(manualCards);
      if (status) status.hidden = true;
    }

    fetchFirstWorking(buildApiCandidates(apiUrl))
      .then(function (payload) {
        apiBrands = dedupeApiBrands(
          normalizePayload(payload).filter(function (brand) {
            return text(brand && brand.name);
          })
        );

        buildCardsFromMode();
      })
      .catch(function (error) {
        console.warn("[Trusted Brands] API unavailable:", error);

        if (sourceMode !== "api" && manualCards.length) {
          activeCards = manualCards;
          render(activeCards);
          if (status) status.hidden = true;
          return;
        }

        if (status) {
          status.hidden = false;
          status.textContent = "No brands are currently available.";
        }
      });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", function (event) {
      if (!root.contains(event.relatedTarget)) startAutoplay();
    });

    var resizeTimer = 0;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (activeCards.length) render(activeCards);
      }, 180);
    });
  }

  function boot() {
    document.querySelectorAll("[data-unisource-brands]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();